/* ============================================================
   TURBOTUBES — tech section spin-up race controller (v2 BMX)
   Phases: idle → p0 (rotating mass lesson) → p1 (weight drop)
           → p2 (gate start + race) → done (verdict)
   BMX gate cadence: red … yellow, yellow, green → GO.
   Spokes + knobby tread rotate; spokes blur out at speed.
   Pace tweak via --ttx-pace.
   ============================================================ */
(function () {
  "use strict";

  const root = document.getElementById("ttx");
  if (!root) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const q = (sel, el) => (el || root).querySelector(sel);

  /* deg/s race speed + per-wheel angular acceleration (deg/s²) */
  const OMEGA = 600;
  const sides = {
    rubber: { el: q('[data-side="rubber"]'), accel: 240 },
    tpu: { el: q('[data-side="tpu"]'), accel: 400 },
  };
  Object.values(sides).forEach((s) => {
    s.rots = s.el.querySelectorAll("[data-rot]");
    s.spokeG = q(".ttx-spokes", s.el);
    s.disc = q(".w-spindisc", s.el);
    s.streaks = q(".w-streaks", s.el);
    s.fill = q("[data-fill]", s.el);
    s.clock = q("[data-clock]", s.el);
    s.flag = q("[data-flag]", s.el);
    s.theta = 0; s.omega = 0; s.doneAt = 0; s.racing = false;
  });
  const weightEl = q("[data-w]");
  const gateLights = root.querySelectorAll(".ttx-gate .gl");
  /* BMX cadence: red (riders ready)… then yellow, yellow, green */
  const gateCadence = [560, 330, 330, 0];

  const pace = () => {
    const v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--ttx-pace"));
    return v > 0 ? v : 1;
  };
  let runId = 0;
  const wait = (ms) => new Promise((r) => setTimeout(r, ms / pace()));
  const frame = () => new Promise((r) => setTimeout(r, 60));

  function setPhase(p) { root.dataset.phase = p; }

  /* ---------- weight countdown 150 → 41 ---------- */
  function countWeight(from, to, dur) {
    const id = runId;
    const t0 = performance.now();
    const d = dur / pace();
    (function tick(now) {
      if (id !== runId) return;
      const k = Math.min(1, (now - t0) / d);
      const e = 1 - Math.pow(1 - k, 3);
      weightEl.textContent = Math.round(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  }

  /* ---------- spin loop ---------- */
  let rafOn = false, last = 0, simClock = 0, raceOn = false, coastAt = 0;

  function loop(now) {
    if (!rafOn) return;
    const dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    const simDt = dt * pace();
    if (raceOn) simClock += simDt;
    let alive = false;

    Object.keys(sides).forEach((k) => {
      const s = sides[k];
      if (s.racing) {
        if (!s.doneAt) {
          s.omega = Math.min(OMEGA, s.omega + s.accel * simDt);
          if (s.omega >= OMEGA) {
            s.doneAt = simClock;
            s.clock.textContent = simClock.toFixed(2) + "s";
            showFlag(k);
          } else {
            s.clock.textContent = simClock.toFixed(2) + "s";
          }
        } else if (coastAt && simClock > coastAt) {
          s.omega = Math.max(0, s.omega - 300 * simDt);
          if (s.omega === 0) s.racing = false;
        }
      }
      if (s.omega > 0 || s.racing) alive = true;
      s.theta = (s.theta + s.omega * simDt) % 360;
      const tf = "rotate(" + s.theta.toFixed(2) + "deg)";
      s.rots.forEach((g) => { g.style.transform = tf; });
      const sp = s.omega / OMEGA;
      /* real spokes vanish at speed: fade them, fade in the dark blur disc */
      s.spokeG.style.opacity = (1 - 0.62 * sp).toFixed(3);
      s.disc.style.opacity = (sp * 0.4).toFixed(3);
      s.streaks.style.opacity = (sp * sp * 0.85).toFixed(3);
      /* once a wheel has reached race speed, its bar stays full */
      s.fill.style.width = s.doneAt ? "100%" : (sp * 100).toFixed(1) + "%";
    });

    if (!alive) { rafOn = false; raceOn = false; return; }
    requestAnimationFrame(loop);
  }
  function startLoop() {
    if (!rafOn) { rafOn = true; last = performance.now(); requestAnimationFrame(loop); }
  }

  function showFlag(k) {
    const s = sides[k];
    if (k === "tpu") {
      s.flag.textContent = "At race speed — first";
    } else {
      const gap = sides.tpu.doneAt ? s.doneAt - sides.tpu.doneAt : 0;
      s.flag.textContent = "+" + gap.toFixed(1) + "s behind";
      coastAt = simClock + 2.4; /* let both coast, then spin down */
    }
    s.flag.classList.add("show");
  }

  /* ---------- reset ---------- */
  function reset() {
    raceOn = false; coastAt = 0; simClock = 0;
    root.classList.remove("go");
    gateLights.forEach((l) => l.classList.remove("on"));
    Object.values(sides).forEach((s) => {
      s.omega = 0; s.theta = 0; s.doneAt = 0; s.racing = false;
      s.rots.forEach((g) => { g.style.transform = "rotate(0deg)"; });
      s.spokeG.style.opacity = "";
      s.disc.style.opacity = "";
      s.streaks.style.opacity = "0";
      s.fill.style.width = "0%";
      s.clock.textContent = "0.00s";
      s.flag.textContent = "";
      s.flag.classList.remove("show");
    });
    sides.tpu.el.classList.remove("slim");
    weightEl.textContent = "150";
    setPhase("idle");
  }

  /* ---------- reduced motion: jump to end state ---------- */
  function finishInstant() {
    reset();
    sides.tpu.el.classList.add("slim");
    weightEl.textContent = "41";
    gateLights.forEach((l) => l.classList.add("on"));
    Object.keys(sides).forEach((k) => {
      const s = sides[k];
      const t = OMEGA / s.accel;
      s.fill.style.width = "100%";
      s.clock.textContent = t.toFixed(2) + "s";
      s.doneAt = t;
    });
    sides.tpu.flag.textContent = "At race speed — first";
    sides.rubber.flag.textContent = "+" + (OMEGA / sides.rubber.accel - OMEGA / sides.tpu.accel).toFixed(1) + "s behind";
    sides.tpu.flag.classList.add("show");
    sides.rubber.flag.classList.add("show");
    setPhase("done");
  }

  /* ---------- timeline ---------- */
  async function play() {
    const id = ++runId;
    reset();
    if (reduced) { finishInstant(); return; }
    await frame();
    if (id !== runId) return;

    /* p0 — the physics lesson: rim weight counts ~2× */
    setPhase("p0");
    await wait(2300); if (id !== runId) return;

    /* p1 — strip the weight: 150g → 41g, band slims */
    setPhase("p1");
    sides.tpu.el.classList.add("slim");
    countWeight(150, 41, 950);
    await wait(2300); if (id !== runId) return;

    /* p2 — BMX gate: red … yellow, yellow, green → GO */
    setPhase("p2");
    await wait(420); if (id !== runId) return;
    for (let i = 0; i < gateLights.length; i++) {
      gateLights[i].classList.add("on");
      if (gateCadence[i]) { await wait(gateCadence[i]); if (id !== runId) return; }
    }
    root.classList.add("go");
    simClock = 0; raceOn = true;
    sides.rubber.racing = true;
    sides.tpu.racing = true;
    startLoop();

    /* wait for the slower wheel to arrive, then verdict */
    while (!sides.rubber.doneAt) { await wait(90); if (id !== runId) return; }
    await wait(700); if (id !== runId) return;
    setPhase("done");
  }

  /* ---------- triggers ---------- */
  let played = false;
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting && !played) { played = true; play(); io.disconnect(); }
    }),
    { threshold: 0.35 }
  );
  io.observe(root);

  const replayBtn = q(".ttx-replay");
  if (replayBtn) replayBtn.addEventListener("click", () => { played = true; play(); });
  window.addEventListener("ttx:replay", () => { played = true; play(); });
})();
